import React from 'react';
import { QuestionnaireProvider } from '@/components/Questionnaire/QuestionnaireProvider';
import type { Questionnaire } from '@/typings/Questionnaire';
import { SectionTemplate, UpdateResponseData } from '@typings/questionnaires-api-models';
import FormContent from './FormContent';

type Props = {
  formData:
    & Parameters<typeof QuestionnaireProvider>[0]['formData']
    & Parameters<typeof FormContent>[0]['formData'];
  isCompleted: boolean;
  questionnaireResponses: Parameters<typeof QuestionnaireProvider>[0]['questionnaireResponses'];
  isEnabled: boolean;
  onSubmit: (responses: UpdateResponseData, isCompleted?: boolean) => Promise<boolean>;
  fieldsByKey: Record<string, Questionnaire.Field>;
  getFieldTemplatesForSectionTemplate: (section: Pick<SectionTemplate, 'id' | 'slug' | 'questionnaireTemplateId'>) => Promise<void>;
  userWorkflowId: string | null;
  shouldForceComplete?: boolean;
};

const DynamicForm: React.FC<Props> = ({
  getFieldTemplatesForSectionTemplate,
  fieldsByKey,
  isEnabled,
  formData,
  questionnaireResponses,
  onSubmit,
  isCompleted,
  userWorkflowId,
  shouldForceComplete,
}) => (
  <QuestionnaireProvider
    aiAutofillActions={['ai-agent', 'get-filing-county', 'get-filing-district']}
    fieldsByKey={fieldsByKey}
    formData={formData}
    questionnaireResponses={questionnaireResponses ?? []}
    onSubmit={onSubmit}
    userWorkflowId={userWorkflowId}
    enabled={isEnabled}
  >
    <FormContent
      getFieldTemplatesForSectionTemplate={getFieldTemplatesForSectionTemplate}
      formData={formData}
      isCompleted={isCompleted}
      shouldForceComplete={shouldForceComplete}
    />
  </QuestionnaireProvider>
);

export default DynamicForm;
